import React from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap is imported

const ModalComponent = ({
  title,
  show,
  onHide,
  size = "lg",
  children,
  backdrop = "static",
  closeIcon = true,
  handleClose,
}) => {
  return (
    <Modal
      size={size}
      show={show}
      onHide={onHide}
      aria-labelledby="modal-title"
      backdrop={backdrop}
    >
      <Modal.Header>
        <Modal.Title id="modal-title">{title}</Modal.Title>
        {closeIcon && (
          <i
            className="fa-solid fa-xmark close-container"
            onClick={handleClose}
            style={{ cursor: "pointer" }}
          ></i>
        )}
      </Modal.Header>
      <hr />
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default ModalComponent;
